import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import Layout from "../../layouts/layout";
import Index from "../VBSAReport";


export default function VBSAReport() {
  return (
    <>
      <Sidebar />
      <Header />
      <Layout>
        <Index />
      </Layout>
    </>
  );
}
